// extracted by mini-css-extract-plugin
module.exports = {"root":"k_M","leadMediaThumb":"k_4","title":"k_Y","excerpt":"k_5"};